module.exports = __webpack_public_path__ + "img/iconImg1.1098869d.png";